"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Accident = function Accident() {
    return _react2.default.createElement(
        "g",
        { id: "accident" },
        _react2.default.createElement(
            "g",
            { id: "Group-11", transform: "translate(1.000000, 4.000000)" },
            _react2.default.createElement("path", { d: "M62.6,344.3c-5.5,0-11-2.1-15.1-6.2c-6.8-6.7-8.2-17.1-3.5-25.5L91.2,228L10,184.5 C1.8,180.1-2.6,171-0.9,161.9c1.6-9.1,9-16.1,18.1-17.3l72.1-9.7L71,77.7c-2.9-9.1,0.6-19,8.5-24.2c7.9-5.3,18.4-4.7,25.7,1.6 l67.3,57.6l68.3-55.7c7.2-5.8,17.3-6.4,25.1-1.3c7.8,5,11.4,14.5,8.9,23.5L256.6,146c-3.1,11.4-14.7,18.1-26.2,15 c-11.4-3.1-18-14.8-15-26.2l0.8-2.8l-30.6,25c-8,6.5-19.5,6.4-27.3-0.3l-23.8-20.3l3.2,9.8c1.9,6,1.1,12.6-2.3,17.9 c-3.4,5.3-8.9,8.9-15.2,9.7L88.1,178l42.3,22.7c5,2.7,8.8,7.3,10.4,12.8c1.6,5.5,0.9,11.4-1.9,16.4l-21,37.6l10.2-5.7 c10.3-5.8,23.3-2.1,29,8.2c5.8,10.3,2.1,23.2-8.2,29L73,341.6C69.7,343.4,66.1,344.3,62.6,344.3z" }),
            _react2.default.createElement("path", { d: "M242.2,392.4c-19.2,0-38.8-0.8-47.5-3.7c-4.2-1.4-11.9-5.4-15.6-16.3c-9-26.3,8.6-152.2,21-170.8 c5.4-8.2,14.5-21.8,123.4-20.1l151.5-1.6c0.1,0,0.2,0,0.2,0c11.7,0,21.2,9.4,21.3,21.1c0.1,11.8-9.3,21.4-21.1,21.5l-152.1,1.6 c-33.9-0.5-74.4,1.2-89,4.7c-5.9,20.2-15.8,91.6-15.6,120.5c13,0.6,34.7,0.5,53-0.1c12.2-0.7,21.6,8.8,22,20.6 c0.4,11.8-8.8,21.6-20.6,22C264.6,392.1,253.5,392.4,242.2,392.4z M230.7,230L230.7,230L230.7,230z" }),
            _react2.default.createElement("path", { d: "M333.4,214c-2.9,0-5.8-0.6-8.6-1.8c-10.8-4.7-15.7-17.3-10.9-28.1l58.8-133.4c3.3-7.4,10.4-12.3,18.5-12.7 l85.2-4.1c11.5-0.6,21.8,8.5,22.3,20.3c0.6,11.7-8.5,21.7-20.3,22.3l-72.1,3.4l-53.5,121.4C349.4,209.2,341.6,214,333.4,214z" }),
            _react2.default.createElement("path", { d: "M475.4,396.9h-71c-11.8,0-21.3-9.5-21.3-21.3s9.5-21.3,21.3-21.3h71c11.8,0,21.3,9.5,21.3,21.3 S487.2,396.9,475.4,396.9z" }),
            _react2.default.createElement("path", { d: "M337.1,460.1c-45.9,0-83.2-37.3-83.2-83.2c0-45.9,37.3-83.2,83.2-83.2s83.2,37.3,83.2,83.2 C420.3,422.8,383,460.1,337.1,460.1z M337.1,336.4c-22.4,0-40.5,18.2-40.5,40.5c0,22.4,18.2,40.6,40.5,40.6 c22.4,0,40.6-18.2,40.6-40.6C377.7,354.6,359.5,336.4,337.1,336.4z" })
        )
    );
};

exports.default = Accident;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Accident.js
// module id = 2914
// module chunks = 4